module.exports = __webpack_public_path__ + "static/media/s_v5_t7_1.0611f284.mp3";